<div class=" h-full w-full p-4">
    <div class="flex flex-rows ">
        <p class="tab-name">Plaza Information</p>
        <div  >
            <button class="flex flex-rows relative ml-[30vw]" mat-icon-button (click)="close()">
                <mat-icon [svgIcon]="'heroicons_outline:close-window'"></mat-icon>
            </button>
        </div>
    </div>
    <hr class="mt-[2vh]">
    <div class="flex flex-rows w-full mt-[0.5vh]" >
        <div class="relative mt-3 mb-1 flex flex-row tab-layout" >
            <div [ngClass]="selectedTab == 0 ? 'selected-tab' : 'unselected-tab'" (click)="displayVideoProcessedDetails()">
                <p class="text-center w-[7vw]" [ngClass]="selectedTab == 0 ? 'selected-tab-text' : 'unselected-tab-text'">
                    Video Processed         
                </p>                                
            </div>
            <div>
                <img src="assets/images/dividor.jpg" class="img-dividor">
            </div>
            <div [ngClass]="selectedTab == 1 ? 'selected-tab' : 'unselected-tab'" (click)="displayKMsCoveredDetails()">
                <p class="text-center w-[6vw]" [ngClass]="selectedTab == 1 ? 'selected-tab-text' : 'unselected-tab-text'">
                    KMs Covered
                </p>
            </div>
            <div>
                <img src="assets/images/dividor.jpg" class="img-dividor">
            </div>
            <div [ngClass]="selectedTab == 2 ? 'selected-tab' : 'unselected-tab'" (click)="displayIdleHoursDetails()">
                <p class="text-center w-[6vw]" [ngClass]="selectedTab == 2 ? 'selected-tab-text' : 'unselected-tab-text'">
                    Idle Hours
                </p>
            </div>
        </div>
        <!-- <div class=" relative top-[20px] ml-[6vw]">
            <span style="position: relative;top: 3px !important;margin-right: 7px !important;">LHS</span>
            <span class="lhs-btn cursor-pointer" (click)="onLHSClick('centerbg-0')"></span>
            <span class="center-combined-lhs-rhs" (click)="onLHSAndRHSClick('centerbg-0')"></span>
            <span class="rhs-btn cursor-pointer" (click)="onRHSClick('centerbg-0')"></span>
            <span class="center-bg-lhs-rhs" [id]="'centerbg-0'"></span>       
            <span style="top: 3px !important;margin-left: 69px !important;position: relative !important;">RHS</span>
        </div> -->
    </div>
    <hr class="mt-[1vh]">
    <table class="mt-[2vh] w-full" *ngIf="selectedTab === 0">
        <tr class="table-header-style grid grid-cols-4">
            <th class="table-header">
                Plaza
            </th>
            <th class="table-header">
                Day
            </th>
            <th class="table-header">
                Night
            </th>
            <th class="table-header">
                Total
            </th>
        </tr>
        <tr class="grid grid-cols-4" *ngFor="let video_pro of total_video_processed">
            <td class=" table-header p-[10px]">
                {{video_pro.plaza}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro["lhs/rhs"].lhs["day/night"].day + video_pro["lhs/rhs"].rhs["day/night"].day}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro["lhs/rhs"].lhs["day/night"].night + video_pro["lhs/rhs"].rhs["day/night"].night}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro["lhs/rhs"].lhs["day/night"].day + video_pro["lhs/rhs"].lhs["day/night"].night + 
                video_pro["lhs/rhs"].rhs["day/night"].day + video_pro["lhs/rhs"].rhs["day/night"].night}}
            </td>
        </tr>         
        <tr class="grid grid-cols-4">
            <td class=" table-header p-[10px]">
                Total
            </td>
            <td class=" table-header p-[10px]">
                {{video_processed["lhs/rhs/all_plazas_data"].lhs["day/night"].day + video_processed["lhs/rhs/all_plazas_data"].rhs["day/night"].day}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_processed["lhs/rhs/all_plazas_data"].lhs["day/night"].night + video_processed["lhs/rhs/all_plazas_data"].rhs["day/night"].night}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_processed["lhs/rhs/all_plazas_data"].lhs["day/night"].day + video_processed["lhs/rhs/all_plazas_data"].lhs["day/night"].night + 
                video_processed["lhs/rhs/all_plazas_data"].rhs["day/night"].day + video_processed["lhs/rhs/all_plazas_data"].rhs["day/night"].night}}
            </td>
        </tr> 
    </table>

    <table class="mt-[2vh] w-full" *ngIf="selectedTab === 1">
        <tr class="table-header-style grid grid-cols-4">
            <th class="table-header">
                Plaza
            </th>
            <th class="table-header">
                Day
            </th>
            <th class="table-header">
                Night
            </th>
            <th class="table-header">
                Total
            </th>
        </tr>
        <tr class="grid grid-cols-4" *ngFor="let video_pro of total_kms_plaza_details">
            <td class=" table-header p-[10px]">
                {{video_pro.plaza}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro.day}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro.night}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro.total}}
            </td>
        </tr>         
        <tr class="grid grid-cols-4">
            <td class=" table-header p-[10px]">
                Total
            </td>
            <td class=" table-header p-[10px]">
                {{total_day_kms}}
            </td>
            <td class=" table-header p-[10px]">
                {{total_night_kms}}
            </td>
            <td class=" table-header p-[10px]">
                {{total_day_night_kms}}
            </td>
        </tr> 
        
    </table>

    <table class="mt-[2vh] w-full" *ngIf="selectedTab === 2">
        <tr class="table-header-style grid grid-cols-4">
            <th class="table-header">
                Plaza
            </th>
            <th class="table-header">
                Day
            </th>
            <th class="table-header">
                Night
            </th>
            <th class="table-header">
                Total
            </th>
        </tr>        
        <tr class="grid grid-cols-4" *ngFor="let video_pro of total_idle_hrs_data">
            <td class=" table-header p-[10px]">
                {{video_pro.plaza}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro.day}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro.night}}
            </td>
            <td class=" table-header p-[10px]">
                {{video_pro.total}}
            </td>
        </tr>         
        <tr class="grid grid-cols-4">
            <td class=" table-header p-[10px]">
                Total
            </td>
            <td class=" table-header p-[10px]">
                {{total_day_idle_data}}
            </td>
            <td class=" table-header p-[10px]">
                {{total_night_idle_data}}
            </td>
            <td class=" table-header p-[10px]">
                {{total_day_night_idle_data}}
            </td>
        </tr> 
    </table>
    <div class="grid justify-end relative right-[1vw] top-[2vh]">
        <button class="moveBtn hover:shadow-lg " (click)="close()">
            <p class="btnText text-lg font-bold" style="width:160px !important;height:19px !important; cursor:pointer;bottom: 2px !important;position: relative;">
                Close
            </p>
        </button>
    </div>
</div>